import context from "@helpers/context";

const [SalonManagerContext, useSalonManagerContext] = context<Admin.Contexts.SalonManager>()

export default SalonManagerContext
export { useSalonManagerContext }